import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { CSSProperties, ReactNode, createElement } from 'react'
import { GovUKLabel } from './GovUKLabel'
import { GovUKHint } from './GovUKHint'

interface GovUKFormGroupProps {
  label: string
  htmlFor: string
  hint?: string
  labelSize?: 's' | 'm' | 'l' | 'xl'
  /** Wraps the label in a heading tag using govuk-label-wrapper (for large labels) */
  labelAs?: 'h1' | 'h2' | 'h3'
  children: ReactNode
  className?: string
  style?: CSSProperties
}

export function GovUKFormGroup({
  label,
  htmlFor,
  hint,
  labelSize,
  labelAs,
  children,
  className,
  style,
}: GovUKFormGroupProps) {
  const classes = ['govuk-form-group', className].filter(Boolean).join(' ')

  const labelElement = (
    <GovUKLabel size={labelSize} htmlFor={htmlFor}>
      {label}
    </GovUKLabel>
  )

  return (
    <div className={classes} style={style}>
      {labelAs
        ? createElement(labelAs, { className: 'govuk-label-wrapper' }, labelElement)
        : labelElement}
      {hint && <GovUKHint>{hint}</GovUKHint>}
      {children}
    </div>
  )
}
